<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/1BDctkW/tc-custom/9781504076869.jpg?1701950710705" alt="This image is the cover for the book Vanishing Patient, The Dr. Cathy Moreland Mysteries"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Vanishing Patient, The Dr. Cathy Moreland Mysteries
      </h1>
      <p class="bookDescription body article font2">
        <b>A doctor begins to doubt her own sanity as she investigates a patient’s wild claims in this new mystery from the author of <i>Lethal Resuscitation</i> . . .</b><br/><br/> Dr. Cathy Moreland is taken aback when an irate patient comes to her practice claiming his ailing wife has been kidnapped by one of her colleagues using a false name. Is someone impersonating a doctor, or is Adam Steer delusional?<br/><br/> After looking into Adam’s claims, she feels reassured that no such thing actually happened—but continues to worry that Steer is mentally unwell. A visit to his home only leads to more alarm. No one answers the door, but Cathy overhears a conversation that convinces her something sinister is going on—and that she herself may be in danger.<br/><br/> Cathy’s own bipolar disorder is well-managed, but she’s beginning to doubt her own sanity—and others are, too. As strange developments unfold, will she be able to make any sense of the events around her before everything spirals out of control?
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Mairi Chong
      </h2>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Bloodhound Books
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?43f7e270